import { Logger, LoggerService } from '@Shared/logger';
import { FeaturesOptions } from './_models';
import { FeaturesService } from './services';

export class FeaturesModuleClass {
  private Logger: Logger = LoggerService.createLogger('FeaturesModule');

  constructor() {
    this.Logger.trace('**** CTOR ****');
  }

  public async init(options: FeaturesOptions): Promise<void> {
    this.Logger.trace('setting up Features Module...', options);
    await FeaturesService.Instance.init(options);
    return Promise.resolve();
  }
}

export const FeaturesModule = new FeaturesModuleClass();
